/* ------------------------------------------------------------------
   dz-quiz.js - Steuerung der Section dz-quiz (Runde 49).

   Vanilla, kein Framework, keine externe Abhaengigkeit. Eingebunden mit
   defer aus sections/dz-quiz.liquid.

   Die Produktdaten kommen NICHT ueber fetch, sondern als JSON-Block, den
   Liquid beim Rendern der Seite erzeugt. Grund: das Matching braucht
   custom.duftrichtungen, shopify.occasion und shopify.season, und
   /collections/<handle>/products.json liefert keine Metafelder. Der alte
   Lantern-Finder hat genau das versucht und konnte deshalb nur nach
   Kollektionen filtern statt nach Duftprofil.

   Add-to-Cart laeuft NICHT ueber einen eigenen fetch, sondern ueber das
   <product-form>-Element des Themes. Damit gelten fuer die Quiz-Karten
   dieselben Regeln wie auf der PDP: dieselbe Fehlerbehandlung, dieselbe
   Section-Neuzeichnung ueber die fuenf Anker und derselbe Weg, auf dem
   der Drawer aufgeht. Eigener Code wuerde diesen Vertrag duplizieren und
   beim naechsten Theme-Update auseinanderlaufen.
   ------------------------------------------------------------------ */

(function () {
  "use strict";

  /* Vibe -> Duftrichtungen, je Treffer +2. */
  var VIBE = {
    clean: ["Frisch", "Blumig"],
    ueberwaeltigend: ["Süß", "Cremig"],
    elegant: ["Holzig", "Würzig"],
    "warm-sexy": ["Orientalisch", "Süß"],
    spritzig: ["Zitrus", "Frisch", "Fruchtig"],
    dark: ["Ledrig", "Rauchig", "Holzig"],
  };

  /* Anlass -> Werte aus shopify.occasion, ein Treffer genuegt fuer +1.
     Die Werteliste des Shops (Stand 24.09.2026, Kollektion alle-dufte):
     alltaeglich, arbeit, abendveranstaltung, date-night,
     besonderer-anlass, freizeit, urlaub, sport, formell.
     Einen Wert "party" gibt es nicht - Party wird deshalb auf
     abendveranstaltung und besonderer-anlass abgebildet. */
  var ANLASS = {
    alltag: ["alltaeglich", "arbeit"],
    date: ["date-night", "abendveranstaltung"],
    party: ["abendveranstaltung", "besonderer-anlass"],
    business: ["arbeit", "formell"],
  };

  /* Geschlecht ist ein harter Filter. Der Buchstabe steht vorn im
     Produkttitel (U1, W80, M120, S201) und wird in Liquid ausgelesen.
     Unisex und Specials laufen bei beiden Geschlechtern mit. */
  var GESCHLECHT = { damen: ["W", "U", "S"], herren: ["M", "U", "S"] };

  var SCHRITTE = 5;

  function esc(t) {
    return String(t == null ? "" : t)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function ereignis(name, nutzlast) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, nutzlast || {}));
    } catch (e) {
      /* Tracking darf das Quiz nie anhalten. */
    }
  }

  function start(wurzel) {
    var datenKnoten = document.getElementById(wurzel.getAttribute("data-daten"));
    var daten = { produkte: [], bundle: null };
    try {
      daten = JSON.parse(datenKnoten.textContent);
    } catch (e) {
      daten = { produkte: [], bundle: null };
    }
    var produkte = daten.produkte || [];

    var schritte = [].slice.call(wurzel.querySelectorAll("[data-schritt]"));
    var ergebnisBox = wurzel.querySelector("[data-ergebnis]");
    var trefferBox = wurzel.querySelector("[data-treffer]");
    var hinweisBox = wurzel.querySelector("[data-hinweis]");
    var bundleBox = wurzel.querySelector("[data-bundle]");

    var zustand = { gender: "", richtungen: [], vibe: "", anlass: "", saison: "" };
    var aktuell = 1;
    var gestartet = false;

    /* ---- Anzeige --------------------------------------------------- */

    function balkenSetzen(n) {
      [].forEach.call(wurzel.querySelectorAll("[data-balken]"), function (b) {
        b.style.width = Math.round((n / SCHRITTE) * 100) + "%";
      });
      [].forEach.call(wurzel.querySelectorAll("[data-fortschritt]"), function (b) {
        b.setAttribute("aria-valuenow", String(n));
      });
    }

    function zeigeSchritt(n, fokus) {
      aktuell = n;
      schritte.forEach(function (s) {
        s.hidden = Number(s.getAttribute("data-schritt")) !== n;
      });
      if (ergebnisBox) ergebnisBox.hidden = true;
      balkenSetzen(n);
      var aktiv = wurzel.querySelector('[data-schritt="' + n + '"]');
      if (aktiv && fokus !== false) {
        var frage = aktiv.querySelector("[data-frage]");
        if (frage) frage.focus();
      }
      /* Nur nach echter Interaktion melden - der erste Aufbau der Seite
         ist kein Schritt, sonst steht in jeder Sitzung ein quiz_step 1,
         auch wenn niemand das Quiz angefasst hat. */
      if (gestartet) ereignis("quiz_step", { quiz_schritt: n });
    }

    function zeigeErgebnis(fokus) {
      schritte.forEach(function (s) {
        s.hidden = true;
      });
      if (ergebnisBox) {
        ergebnisBox.hidden = false;
        if (fokus !== false) {
          var h = ergebnisBox.querySelector("[data-ergebnis-titel]");
          if (h) h.focus();
        }
      }
      balkenSetzen(SCHRITTE);
    }

    /* ---- Auswahl ---------------------------------------------------- */

    function knopfStand(schrittEl) {
      var max = Number(schrittEl.getAttribute("data-max") || 1);
      var key = schrittEl.getAttribute("data-key");
      var gewaehlt = key === "richtungen" ? zustand.richtungen : zustand[key] ? [zustand[key]] : [];
      [].forEach.call(schrittEl.querySelectorAll("[data-antwort]"), function (b) {
        var an = gewaehlt.indexOf(b.getAttribute("data-value")) > -1;
        b.setAttribute("aria-pressed", an ? "true" : "false");
        if (max > 1) b.disabled = !an && gewaehlt.length >= max;
      });
      var weiter = schrittEl.querySelector("[data-weiter]");
      if (weiter) weiter.disabled = gewaehlt.length === 0;
      var zaehler = schrittEl.querySelector("[data-zaehler]");
      if (zaehler) zaehler.textContent = gewaehlt.length + " von " + max + " gewählt";
    }

    function waehle(btn) {
      var schrittEl = btn.closest("[data-schritt]");
      if (!schrittEl) return;
      if (!gestartet) {
        gestartet = true;
        ereignis("quiz_start", {});
      }
      var key = schrittEl.getAttribute("data-key");
      var max = Number(schrittEl.getAttribute("data-max") || 1);
      var wert = btn.getAttribute("data-value");

      if (max > 1) {
        var i = zustand.richtungen.indexOf(wert);
        if (i > -1) zustand.richtungen.splice(i, 1);
        else if (zustand.richtungen.length < max) zustand.richtungen.push(wert);
        knopfStand(schrittEl);
        return;
      }

      zustand[key] = wert;
      knopfStand(schrittEl);
      var n = Number(schrittEl.getAttribute("data-schritt"));
      /* Einfachauswahl springt beim Tippen weiter. Die kurze Pause zeigt
         dem Finger, dass die Karte getroffen wurde. */
      window.setTimeout(function () {
        weiterVon(n);
      }, 220);
    }

    function weiterVon(n) {
      if (n >= SCHRITTE) {
        fertig();
        return;
      }
      zeigeSchritt(n + 1);
    }

    /* ---- Matching ---------------------------------------------------- */

    function inFrage(p) {
      var erlaubt = GESCHLECHT[zustand.gender] || [];
      return erlaubt.indexOf(p.g) > -1;
    }

    function punkte(p) {
      var pkt = 0;
      var d = p.d || [];
      zustand.richtungen.forEach(function (r) {
        if (d.indexOf(r) > -1) pkt += 3;
      });
      (VIBE[zustand.vibe] || []).forEach(function (r) {
        if (d.indexOf(r) > -1) pkt += 2;
      });
      var anl = ANLASS[zustand.anlass] || [];
      var o = p.o || [];
      for (var i = 0; i < anl.length; i++) {
        if (o.indexOf(anl[i]) > -1) {
          pkt += 1;
          break;
        }
      }
      if ((p.s || []).indexOf(zustand.saison) > -1) pkt += 1;
      return pkt;
    }

    function auswerten() {
      var pool = [];
      produkte.forEach(function (p, idx) {
        if (!inFrage(p)) return;
        pool.push({ p: p, idx: idx, pkt: punkte(p) });
      });
      /* Gleichstand -> Reihenfolge der Kollektion alle-dufte. */
      var sortiert = pool.slice().sort(function (a, b) {
        return b.pkt - a.pkt || a.idx - b.idx;
      });
      var treffer = sortiert.filter(function (e) {
        return e.pkt > 0;
      }).slice(0, 3);
      if (treffer.length < 3) {
        /* Zu wenige Treffer -> mit den Beliebtesten des Geschlechts
           auffuellen; beliebt ist hier die Reihenfolge der Kollektion. */
        pool
          .slice()
          .sort(function (a, b) {
            return a.idx - b.idx;
          })
          .forEach(function (e) {
            if (treffer.length >= 3) return;
            if (
              treffer.some(function (t) {
                return t.p.h === e.p.h;
              })
            )
              return;
            treffer.push(e);
          });
      }
      return treffer;
    }

    /* ---- Ergebniskarten ---------------------------------------------- */

    function variantenHtml(p) {
      return (p.v || [])
        .map(function (v, i) {
          var frei = v[4] === 1;
          return (
            '<button type="button" class="dz-quiz__groesse" data-groesse' +
            ' data-vid="' + esc(v[0]) + '"' +
            ' data-preis="' + esc(v[2]) + '"' +
            ' data-streich="' + esc(v[3] || "") + '"' +
            ' aria-pressed="' + (i === 0 && frei ? "true" : "false") + '"' +
            (frei ? "" : " disabled") +
            ">" + esc(v[1]) + "</button>"
          );
        })
        .join("");
    }

    function ersteFreie(p) {
      var v = (p.v || []).filter(function (x) {
        return x[4] === 1;
      });
      return v[0] || (p.v || [])[0] || null;
    }

    function preisZeile(v) {
      if (!v) return "";
      var streich = v[3];
      /* Gruen und Streichpreis nur, wenn es einen gueltigen
         compare_at_price ueber dem Preis gibt - Liquid liefert das Feld
         sonst als leeren String. */
      return (
        '<span class="dz-quiz__preis' + (streich ? " dz-quiz__preis--reduziert" : "") + '" data-preis-aktuell>' +
        esc(v[2]) +
        "</span>" +
        // Kein Grundpreis mehr (Nachtrag 54c). R52 hatte ihn hier je
        // Groesse ausgegeben; das Feld ist auch aus den Daten raus.
        (streich ? '<s class="dz-quiz__streich" data-preis-streich>' + esc(streich) + "</s>" : '<s class="dz-quiz__streich" data-preis-streich hidden></s>')
      );
    }

    function karteHtml(eintrag, rang) {
      var p = eintrag.p;
      var v = ersteFreie(p);
      var tags = (p.d || []).slice(0, 3);
      var noten = p.n || "";
      return (
        '<article class="dz-quiz__tkarte' + (rang === 0 ? " dz-quiz__tkarte--best" : "") + '" data-karte data-handle="' + esc(p.h) + '">' +
        (rang === 0 ? '<span class="dz-quiz__badge">Bester Treffer</span>' : "") +
        '<a class="dz-quiz__tbild" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
        (p.b ? '<img src="' + esc(p.b) + '" width="600" height="600" alt="" loading="lazy" decoding="async">' : "") +
        "</a>" +
        '<div class="dz-quiz__tinhalt">' +
        '<a class="dz-quiz__tname" href="' + esc(p.u) + '">' + esc(p.t) + "</a>" +
        (tags.length ? '<div class="dz-quiz__tags">' + tags.map(function (t) { return '<span class="dz-quiz__tag">' + esc(t) + "</span>"; }).join("") + "</div>" : "") +
        (noten ? '<p class="dz-quiz__noten">' + esc(noten) + "</p>" : "") +
        '<div class="dz-quiz__groessen" role="group" aria-label="Größe wählen">' + variantenHtml(p) + "</div>" +
        '<div class="dz-quiz__preiszeile">' + preisZeile(v) + "</div>" +
        '<product-form class="dz-quiz__pf">' +
        '<form method="post" action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">' +
        '<input type="hidden" name="form_type" value="product">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="id" value="' + esc(v ? v[0] : "") + '" disabled data-variante>' +
        '<button type="submit" name="add" class="dz-quiz__atc" aria-haspopup="dialog"' + (v ? "" : " disabled") + ">In den Warenkorb</button>" +
        "</form>" +
        "</product-form>" +
        "</div>" +
        "</article>"
      );
    }

    function zeichneErgebnis(treffer) {
      if (!trefferBox) return;
      if (!treffer.length) {
        trefferBox.innerHTML = "";
        if (hinweisBox) {
          hinweisBox.hidden = false;
          hinweisBox.textContent = "Zu dieser Auswahl haben wir gerade keinen verfügbaren Duft. Starte das Quiz neu oder stöbere in allen Düften.";
        }
        if (bundleBox) bundleBox.hidden = true;
        return;
      }
      if (hinweisBox) hinweisBox.hidden = true;
      if (bundleBox) bundleBox.hidden = false;
      trefferBox.innerHTML = treffer
        .map(function (e, i) {
          return karteHtml(e, i);
        })
        .join("");
    }

    /* Bundle-Karte: die drei Treffer als Vorbelegung an den Link haengen.
       Die Options-App (Cloudlift) liest jeden Query-Parameter als
       Optionswert, sobald "_f" in der Adresse steht. Der Wert eines
       Duftfeldes ist exakt der Produkttitel - belegt durch Bestellung
       #5419: 'Duft 1' = 'U4 "Obscur Nomad"'. Deshalb wird p.q genommen,
       der Rohtitel, nicht der bereinigte Anzeigename p.t. */
    function bundleLink(treffer) {
      if (!bundleBox) return;
      var basis = bundleBox.getAttribute("data-basis");
      if (!basis) return;
      var feldModus = bundleBox.getAttribute("data-feld-modus");
      var modusWert = bundleBox.getAttribute("data-modus-wert");
      var praefix = bundleBox.getAttribute("data-feld-praefix") || "Duft ";

      /* Specials laufen in der Duftschublade des Bundles nicht mit, und
         ausverkaufte Duefte stehen dort auch nicht zur Wahl. Beide
         werden durch den naechsten Treffer ersetzt. */
      var tauglich = treffer.filter(function (e) {
        return e.p.g !== "S" && (e.p.v || []).some(function (v) { return v[4] === 1; });
      });
      if (tauglich.length < 3) {
        var schon = {};
        tauglich.forEach(function (e) { schon[e.p.h] = true; });
        produkte.forEach(function (p, idx) {
          if (tauglich.length >= 3) return;
          if (schon[p.h] || p.g === "S" || !inFrage(p)) return;
          if (!(p.v || []).some(function (v) { return v[4] === 1; })) return;
          schon[p.h] = true;
          tauglich.push({ p: p, idx: idx, pkt: 0 });
        });
      }
      if (tauglich.length < 3) {
        bundleBox.setAttribute("href", basis);
        return;
      }

      var teile = ["_f=1"];
      if (feldModus && modusWert) {
        teile.push(encodeURIComponent(feldModus) + "=" + encodeURIComponent(modusWert));
      }
      tauglich.slice(0, 3).forEach(function (e, i) {
        teile.push(encodeURIComponent(praefix + (i + 1)) + "=" + encodeURIComponent(e.p.q || e.p.t));
      });
      bundleBox.setAttribute("href", basis + "?" + teile.join("&"));
      bundleBox.setAttribute(
        "data-duefte",
        tauglich.slice(0, 3).map(function (e) { return e.p.q || e.p.t; }).join(" | ")
      );
    }

    function fertig() {
      var treffer = auswerten();
      zeichneErgebnis(treffer);
      bundleLink(treffer);
      urlSchreiben();
      zeigeErgebnis();
      ereignis("quiz_complete", {
        quiz_gender: zustand.gender,
        quiz_richtungen: zustand.richtungen.join(","),
        quiz_vibe: zustand.vibe,
        quiz_anlass: zustand.anlass,
        quiz_saison: zustand.saison,
        quiz_treffer: treffer
          .map(function (t) {
            return t.p.h;
          })
          .join(","),
      });
    }

    /* ---- Teilbare Adresse -------------------------------------------- */

    function slugVon(key, wert) {
      var b = wurzel.querySelector('[data-key-slug="' + key + '"][data-value="' + wert + '"]');
      return b ? b.getAttribute("data-slug") : "";
    }

    function wertVon(key, slug) {
      var b = wurzel.querySelector('[data-key-slug="' + key + '"][data-slug="' + slug + '"]');
      return b ? b.getAttribute("data-value") : "";
    }

    function urlSchreiben() {
      try {
        var r = [
          zustand.richtungen
            .map(function (x) {
              return slugVon("richtungen", x);
            })
            .join(","),
          slugVon("vibe", zustand.vibe),
          slugVon("anlass", zustand.anlass),
          slugVon("saison", zustand.saison),
        ].join("_");
        var u = new URL(window.location.href);
        u.searchParams.set("g", zustand.gender);
        u.searchParams.set("r", r);
        window.history.replaceState({}, "", u.toString());
      } catch (e) {
        /* Ohne History-API laeuft das Quiz weiter, nur ohne teilbare Adresse. */
      }
    }

    function urlLesen() {
      var u;
      try {
        u = new URL(window.location.href);
      } catch (e) {
        return false;
      }
      var g = u.searchParams.get("g");
      var r = u.searchParams.get("r");
      if (!g || !r || !GESCHLECHT[g]) return false;
      var teile = r.split("_");
      if (teile.length !== 4) return false;
      var richtungen = (teile[0] || "")
        .split(",")
        .map(function (sl) {
          return wertVon("richtungen", sl);
        })
        .filter(Boolean)
        .slice(0, 2);
      var vibe = wertVon("vibe", teile[1]);
      var anlass = wertVon("anlass", teile[2]);
      var saison = wertVon("saison", teile[3]);
      if (!vibe || !anlass || !saison) return false;
      zustand = { gender: g, richtungen: richtungen, vibe: vibe, anlass: anlass, saison: saison };
      schritte.forEach(knopfStand);
      var treffer = auswerten();
      zeichneErgebnis(treffer);
      bundleLink(treffer);
      zeigeErgebnis(false);
      return true;
    }

    /* ---- Ereignisse ---------------------------------------------------- */

    wurzel.addEventListener("click", function (e) {
      var t = e.target;

      var antwort = t.closest && t.closest("[data-antwort]");
      if (antwort) {
        e.preventDefault();
        if (!antwort.disabled) waehle(antwort);
        return;
      }

      var weiter = t.closest && t.closest("[data-weiter]");
      if (weiter) {
        e.preventDefault();
        if (weiter.disabled) return;
        if (!gestartet) {
          gestartet = true;
          ereignis("quiz_start", {});
        }
        weiterVon(Number(weiter.closest("[data-schritt]").getAttribute("data-schritt")));
        return;
      }

      var zurueck = t.closest && t.closest("[data-zurueck]");
      if (zurueck) {
        e.preventDefault();
        zeigeSchritt(Number(zurueck.getAttribute("data-zurueck")));
        return;
      }

      var groesse = t.closest && t.closest("[data-groesse]");
      if (groesse) {
        e.preventDefault();
        if (groesse.disabled) return;
        var karte = groesse.closest("[data-karte]");
        if (!karte) return;
        [].forEach.call(karte.querySelectorAll("[data-groesse]"), function (b) {
          b.setAttribute("aria-pressed", b === groesse ? "true" : "false");
        });
        var feld = karte.querySelector("[data-variante]");
        if (feld) feld.value = groesse.getAttribute("data-vid");
        var jetzt = karte.querySelector("[data-preis-aktuell]");
        var strich = karte.querySelector("[data-preis-streich]");
        var streich = groesse.getAttribute("data-streich");
        if (jetzt) {
          jetzt.textContent = groesse.getAttribute("data-preis");
          jetzt.classList.toggle("dz-quiz__preis--reduziert", !!streich);
        }
        if (strich) {
          strich.textContent = streich || "";
          strich.hidden = !streich;
        }
        // 54c: Der Groessenwechsel rendert keinen Grundpreis mehr nach.
        return;
      }

      var neu = t.closest && t.closest("[data-neustart]");
      if (neu) {
        e.preventDefault();
        zustand = { gender: "", richtungen: [], vibe: "", anlass: "", saison: "" };
        schritte.forEach(knopfStand);
        try {
          var u = new URL(window.location.href);
          u.searchParams.delete("g");
          u.searchParams.delete("r");
          window.history.replaceState({}, "", u.toString());
        } catch (err) {
          /* nichts */
        }
        zeigeSchritt(1);
        return;
      }
    });

    /* Der eigentliche Add-to-Cart laeuft im <product-form> des Themes.
       Hier haengt nur das Tracking dran. */
    wurzel.addEventListener(
      "submit",
      function (e) {
        var karte = e.target.closest && e.target.closest("[data-karte]");
        if (!karte) return;
        var feld = karte.querySelector("[data-variante]");
        ereignis("quiz_add_to_cart", {
          quiz_handle: karte.getAttribute("data-handle"),
          quiz_variante: feld ? feld.value : "",
        });
      },
      true
    );

    /* ---- Anlauf --------------------------------------------------------- */

    schritte.forEach(knopfStand);
    if (!urlLesen()) {
      zeigeSchritt(1, false);
      balkenSetzen(1);
    }
    wurzel.removeAttribute("data-wartet");
  }

  function anlauf() {
    [].forEach.call(document.querySelectorAll("[data-dz-quiz]"), start);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", anlauf);
  } else {
    anlauf();
  }
})();
